import React, { useState } from 'react';
import './KnockoutBracket.css';


const Match = ({ seed, isWinner }) => {
  const [hoveredTeam, setHoveredTeam] = useState(null);

  return (
    <div className={`match ${isWinner ? 'winner' : ''}`}>
      <div
        className="team"
        onMouseEnter={() => setHoveredTeam(0)}
        onMouseLeave={() => setHoveredTeam(null)}
        title={seed.teams[0]?.name || 'TBD'}
      >
        <span className="team-name">
          {seed.teams[0]?.name || 'TBD'}
        </span>
        {seed.teams[0]?.score !== undefined && (
          <span className="team-score">
            {seed.teams[0].score}
          </span>
        )}
      </div>
      <div
        className="team"
        onMouseEnter={() => setHoveredTeam(1)}
        onMouseLeave={() => setHoveredTeam(null)}
        title={seed.teams[1]?.name || 'TBD'}
      >
        <span className="team-name">
          {seed.teams[1]?.name || 'TBD'}
        </span>
        {seed.teams[1]?.score !== undefined && (
          <span className="team-score">
            {seed.teams[1].score}
          </span>
        )}
      </div>
    </div>
  );
};

const Round = ({ title, seeds }) => {
  const matchups = [];

  for (let i = 0; i < seeds.length; i += 2) {
    matchups.push({
      match1: seeds[i],
      match2: seeds[i + 1],
    });
  }

  return (
    <div className="round">
      <h5 className="round-title">{title}</h5>
      <div className="matchups">
        {matchups.map((matchup, index) => (
          <div className="matchup" key={index}>
            <Match seed={matchup.match1} />
            {matchup.match2 && <Match seed={matchup.match2} />}
          </div>
        ))}
      </div>
    </div>
  );
};

const KnockoutBracket = ({ left, right, final, title = "Sơ Đồ Thi Đấu" }) => {
  const handlePrint = () => {
    window.print();
  };

  if (!left || !right || !final) {
    return (
      <div className="bracket-container d-flex flex-column align-items-center justify-content-center py-5 text-center">
        <h4 className="fw-bold mb-2">Chưa có dữ liệu</h4>
        <p className="text-muted">Sơ đồ thi đấu sẽ được hiển thị sau khi thực hiện bốc thăm</p>
      </div>
    );
  }

  return (
    <>
      <div className="bracket-header mb-4">
        <div>
          <h2 className="fw-bold mb-1">{title}</h2>
          <p className="text-muted small">Sơ đồ bốc thăm và tiến trình thi đấu</p>
        </div>
        <button
          className="print-button"
          onClick={handlePrint}
          title="In sơ đồ thi đấu"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            width="18"
            height="18"
          >
            <polyline points="6 9 6 2 18 2 18 9"></polyline>
            <path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path>
            <rect x="6" y="14" width="12" height="8"></rect>
          </svg>
          In sơ đồ
        </button>
      </div>

      <div className="bracket-container">
        <div className="bracket-layout">
          {/* LEFT BRACKET */}
          <div className="bracket-side bracket-left">
            {left.map((round, roundIndex) => (
              <Round
                key={`left-${roundIndex}`}
                title={round.title}
                seeds={round.seeds}
              />
            ))}
          </div>

          {/* FINAL MATCH */}
          <div className="bracket-final-area">
            <Round
              title={final.title}
              seeds={final.seeds}
            />
          </div>

          {/* RIGHT BRACKET */}
          <div className="bracket-side bracket-right">
            {right.map((round, roundIndex) => (
              <Round
                key={`right-${roundIndex}`}
                title={round.title}
                seeds={round.seeds}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default KnockoutBracket;
